export const apiVersionPrefix: string = "/api/v1";

export const rewardsApiPrefix: string = `${apiVersionPrefix}/rewards`;
